import { render, staticRenderFns } from "./ResultsMessages.vue?vue&type=template&id=73f63478&"
import script from "./ResultsMessages.vue?vue&type=script&lang=js&"
export * from "./ResultsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports